import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IPaymentConfigEntity } from '../../../entity/interface/iPaymentConfig';
import { IPaymentConfigRepository } from '../../repositories/interfaces/iPaymentConfig';

export interface IGetPaymentUseCase {
    execute(): Promise<IPaymentConfigEntity['data']>;
}

export class GetPaymentUseCase implements IGetPaymentUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getPaymentRepository(): IPaymentConfigRepository {
        return container.resolve<IPaymentConfigRepository>(DI.REPOSITORIES.IPaymentConfigRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(): Promise<IPaymentConfigEntity['data']> {
        const response = await this.getPaymentRepository.getPaymentConfig();
        return response?.data;
    }
}
